import type { AnyCardId, MajorArcanaContent } from './types';

export function getAvailableCards<T extends AnyCardId>({
	cards,
	excluded
}: {
	cards: readonly T[];
	excluded: readonly T[];
}): T[] {
	return cards.filter((id) => !excluded.includes(id));
}

export function pickRandomCard<T extends AnyCardId>(cards: readonly T[]): T | undefined {
	return cards[Math.floor(Math.random() * cards.length)];
}

export function shuffleCards<T extends AnyCardId>(cards: readonly T[]): T[] {
	const shuffled = [...cards];
	for (let index = shuffled.length - 1; index > 0; index--) {
		const randomIndex = Math.floor(Math.random() * (index + 1));
		[shuffled[index], shuffled[randomIndex]] = [shuffled[randomIndex], shuffled[index]];
	}
	return shuffled;
}

export const isMajorCardContentReady = (cardContent: MajorArcanaContent): boolean => {
	return cardContent.boon.length > 0 && cardContent.bane.length > 0;
};
